// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"pw-z","smallCardRow":"qw-z","largeCardRow":"rw-z","productSearchRow":"sw-z","curatedRow":"tw-z"};